import { render, staticRenderFns } from "./OtherDiseaseCard.vue?vue&type=template&id=bfbeff34&scoped=true&"
import script from "./OtherDiseaseCard.vue?vue&type=script&lang=js&"
export * from "./OtherDiseaseCard.vue?vue&type=script&lang=js&"
import style0 from "./OtherDiseaseCard.vue?vue&type=style&index=0&id=bfbeff34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbeff34",
  null
  
)

export default component.exports